<template>
  <div class="row d-flex" :class="defaultHeight && 'height-400'">
    <div class="'sk-spinner sk-spinner-three-bounce true '">
      <div class="sk-bounce1"></div>
      <div class="sk-bounce2"></div>
      <div class="sk-bounce3"></div>
    </div>
  </div>
</template>
<script>

export default {
  name: "Loader",
  props:{
    defaultHeight : {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>

</style>